module.exports = __webpack_public_path__ + "img/国防科技大学智能科学学院.8260ad3e.png";